import React from 'react';
import { connect } from 'react-redux';

import { setFilterAttribute } from 'bundles/connect/components/store/actions/criteria';
import Toggle from './toggle';
import type { Criteria } from 'bundles/connect/types';

type OpportunityZoneToggleInputProps = {
  bordered?: boolean;
  criteria: Criteria;
  noLabel?: boolean;
  setFilterAttribute: (key: string, value: any) => void;
}

function OpportunityZoneToggleInput({
  bordered = false,
  criteria,
  noLabel,
  setFilterAttribute
}: OpportunityZoneToggleInputProps) {
  return (
    <Toggle
      bordered={bordered}
      checked={!!criteria.opportunityZone}
      label={noLabel ? null : <div className="text-nowrap">Opportunity Zone</div>}
      onClick={() => setFilterAttribute('opportunityZone', !criteria.opportunityZone)}
    />
  );
}

const mapStateToProps = ({ criteria }) => ({ criteria });

export default connect(mapStateToProps, { setFilterAttribute })(OpportunityZoneToggleInput);
